export const getNextIndex = (steps, selectedStep)=>{
    const index = steps.findIndex((item)=>item.id === selectedStep.id);
    const nextIndex = (index + 1) % steps.length === 0 ? 0 : index + 1;
    return nextIndex;
};
